import { NgModule } from '@angular/core';

import { LinkyPipe, RemoveGifUrlsPipe } from './linky.pipe';

@NgModule({
  declarations: [LinkyPipe, RemoveGifUrlsPipe],
  exports: [LinkyPipe, RemoveGifUrlsPipe],
})
export class LinkyModule { }